export enum ErrorCodesEnum {
  BAD_REQUEST = '400',
  UNAUTHORIZED = '401',
  FORBIDDEN = '403',
  NOT_FOUND = '404',
  RESET_TOKEN = 'reset_token_expired',
  EXPIRED = 'invite_token_expired',
  INTERNAL_SERVER_ERROR = '500',
}
